<nav aria-label="breadcrumb" class="breadcrumb-container">
  <ol class="breadcrumb">
    <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs; let last = last" [class.active]="last">
      <ng-container *ngIf="breadcrumb.label && breadcrumb.label.trim() !== ''">
        <a *ngIf="!last" [routerLink]="breadcrumb.url" class="breadcrumb-link">
          <mat-icon *ngIf="breadcrumb.label === 'Home'">home</mat-icon>
          <span>{{ breadcrumb.label }}</span>
        </a>
        <span *ngIf="last" class="breadcrumb-current">
          {{ breadcrumb.label }}
        </span>
      </ng-container>
    </li>
  </ol>
</nav>
